import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { Button } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { RequestAuditLogsStore } from 'pages/settings/pages/doubleOptIn/store/requestAuditLogsStore'

export const RequestAuditLogs = observer(() => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new RequestAuditLogsStore(entities))
  const { onOpenModal } = store

  useEffect(() => {
    store.init()
  }, [])

  return (
    <Button
      typeBtn={'contained'}
      contained={'secondary'}
      text={'Request audit logs'}
      onClick={onOpenModal}
    />
  )
})
